module.exports = __webpack_public_path__ + "img/edgeryders_2.a1b085bc.jpg";